import { render, staticRenderFns } from "./superPerDetail.vue?vue&type=template&id=000e5be0&"
import script from "./superPerDetail.vue?vue&type=script&lang=js&"
export * from "./superPerDetail.vue?vue&type=script&lang=js&"
import style0 from "./superPerDetail.vue?vue&type=style&index=0&id=000e5be0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports